import { FaSchool } from "react-icons/fa";

import AppGreenIcon from "./App - Green V2.svg";
import AppGreyIcon from "./App - Grey V2.svg";
import AppOrangeIcon from "./App - Orange V2.svg";

import MartyGreenIcon from "./Marty - Green V2.svg";
import MartyGreyIcon from "./Marty - Grey V2.svg";
import MartyOrangeIcon from "./Marty - Orange V2.svg";

import WarrantyGreenIcon from "./Warrenty - Green V2.svg";
import WarrantyGreyIcon from "./Warrenty - Grey V2.svg";
import WarrantyOrangeIcon from "./Warrenty - Orange V2.svg";


import StatusButton, { StatusButtonStatus } from "../../components/StatusButton";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { getLatestAppVersion, getLatestMartyVersion } from "../../db/news-section-db";
import { getUrlParams } from "../../utils/url-params";
import { isSerialNumberRegistered } from "../../db/warranty-service-db";
import AppDangerModal from "../../modals/status-indicator-modal/app-indicator/DangerModal";
import RobotDangerModal from "../../modals/status-indicator-modal/robot-indicator/DangerModal";
import WarrantyDangerModal from "../../modals/status-indicator-modal/warranty-indicator/DangerModal";

type Props = {
  setIsEducator: (isEducator: boolean) => void;
  isEducator: boolean;
}

export default function StatusButtons({ setIsEducator, isEducator }: Props) {
  const [appVersionStatus, setAppVersionStatus] = useState<StatusButtonStatus>(StatusButtonStatus.DEACTIVATED);
  const [martyVersionStatus, setMartyVersionStatus] = useState<StatusButtonStatus>(StatusButtonStatus.DEACTIVATED);
  const [warrantyServiceStatus, setWarrantyServiceStatus] = useState<StatusButtonStatus>(StatusButtonStatus.DEACTIVATED);

  useEffect(() => {
    const asyncFunc = async () => {
      setAppVersionStatus(StatusButtonStatus.LOADING);
      try {
        const LATEST_APP_VERSION = await getLatestAppVersion();
        const params = getUrlParams();
        if (!params.appVersion) {
          setAppVersionStatus(StatusButtonStatus.DEACTIVATED);
          return;
        }
        if (params.appVersion === "webapp") {
          setAppVersionStatus(StatusButtonStatus.OKAY);
          return;
        }
        setAppVersionStatus(params.appVersion === LATEST_APP_VERSION ? StatusButtonStatus.OKAY : StatusButtonStatus.DANGER);
      } catch (e) {
        setAppVersionStatus(StatusButtonStatus.DEACTIVATED);
      }
    }
    asyncFunc();
  }, []);

  useEffect(() => {
    const asyncFunc = async () => {
      setMartyVersionStatus(StatusButtonStatus.LOADING);
      try {
        const LATEST_MARTY_VERSION = await getLatestMartyVersion();
        const params = getUrlParams();
        if (!params.martyVersion) {
          setMartyVersionStatus(StatusButtonStatus.DEACTIVATED)
          return;
        };
        setMartyVersionStatus(params.martyVersion === LATEST_MARTY_VERSION ? StatusButtonStatus.OKAY : StatusButtonStatus.DANGER);
      } catch (e) {
        setMartyVersionStatus(StatusButtonStatus.DEACTIVATED);
      }
    }
    asyncFunc();
  }, []);

  useEffect(() => {
    const asyncFunc = async () => {
      setWarrantyServiceStatus(StatusButtonStatus.LOADING);
      try {
        const params = getUrlParams();
        if (!params.serialNumber) {
          setWarrantyServiceStatus(StatusButtonStatus.DEACTIVATED);
          return;
        }
        const isRegistered = await isSerialNumberRegistered(params.serialNumber);
        setWarrantyServiceStatus(isRegistered ? StatusButtonStatus.OKAY : StatusButtonStatus.DANGER);
      } catch (e) {
        setWarrantyServiceStatus(StatusButtonStatus.DEACTIVATED);
      }
    }
    asyncFunc();
  }, []);

  return (
    <div className={styles.statusButtonsContainer}>
      <StatusButton
        title="App Version"
        subtitles={{ okay: "App is up to date", danger: "App update is required", deactivated: "Not Connected" }}
        modals={{ danger: <AppDangerModal /> }}
        icons={{ danger: AppOrangeIcon, okay: AppGreenIcon, deactivated: AppGreyIcon, loading: AppGreyIcon, warning: AppOrangeIcon }}
        status={appVersionStatus}
      />
      <StatusButton
        title="Marty Version"
        subtitles={{ okay: "Marty is up to date", danger: "Marty update is required", deactivated: "Marty is not connected" }}
        modals={{ danger: <RobotDangerModal /> }}
        icons={{ danger: MartyOrangeIcon, okay: MartyGreenIcon, deactivated: MartyGreyIcon, loading: MartyGreyIcon, warning: MartyOrangeIcon }}
        status={martyVersionStatus}
      />
      <StatusButton
        title="Warranty Service"
        subtitles={{ okay: "Warranty is activated", danger: "Warranty is not activated. Please register your Marty", deactivated: "Connect to your Marty to find out if warranty is activated" }}
        modals={{ danger: <WarrantyDangerModal /> }}
        icons={{ danger: WarrantyOrangeIcon, okay: WarrantyGreenIcon, deactivated: WarrantyGreyIcon, loading: WarrantyGreyIcon, warning: WarrantyOrangeIcon }}
        status={warrantyServiceStatus}
      />
      {/*<div className={styles.vr} />
       <StatusButton
        title="Educator Feed"
        subtitles={{ okay: "Active Feed", deactivated: "Press to Activate" }}
        icon={FaSchool}
        status={isEducator ? StatusButtonStatus.OKAY : StatusButtonStatus.DEACTIVATED}
        isEducator
        onClick={() => setIsEducator(!isEducator)}
      /> */}
    </div>
  );
}